import { useEffect, useRef, useState } from 'react';
/**
 * check if the text is truncated
 */
export function useIsTruncated(key) {
    const ref = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);
    useEffect(() => {
        const handleResize = () => {
            const { scrollWidth = 0, clientWidth = 0 } = ref.current || {};
            setIsTruncated(scrollWidth > clientWidth);
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, [key]);
    return { ref, isTruncated };
}
